/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Gesperrte Straße`
};

const en_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Closed lane`
};

const es_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Carretera cerrada`
};

const fr_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Route fermée`
};

const it_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Strada chiusa`
};

const nl_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Weg afgesloten`
};

const pt_map_tools__traffic_info_closed_lane__label = /** @type {(inputs: {}) => string} */ () => {
	return `Pista fechada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_closed_lane__label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_tools__traffic_info_closed_lane__label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_tools__traffic_info_closed_lane__label", locale)
	if (locale === "de") return de_map_tools__traffic_info_closed_lane__label(inputs)
	if (locale === "en") return en_map_tools__traffic_info_closed_lane__label(inputs)
	if (locale === "es") return es_map_tools__traffic_info_closed_lane__label(inputs)
	if (locale === "fr") return fr_map_tools__traffic_info_closed_lane__label(inputs)
	if (locale === "it") return it_map_tools__traffic_info_closed_lane__label(inputs)
	if (locale === "nl") return nl_map_tools__traffic_info_closed_lane__label(inputs)
	return pt_map_tools__traffic_info_closed_lane__label(inputs)
};